var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93359 44.9219L2.92969 0H46.9727L42.9688 44.9219L24.9023 50",
    fill: "#E34F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46.0938L39.5508 42.0898L42.9688 3.61328H25",
    fill: "#EF652A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.3125H17.6758L17.1875 14.6484H25V9.17969H11.1328L12.5977 25.8789H25V20.3125ZM24.9023 34.668L18.75 33.0078L18.3594 28.6133H12.8906L13.5742 37.3047L24.9023 40.4297V34.668Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9023 20.3125V25.8789H31.7383L31.0547 33.0078L24.9023 34.668V40.4297L36.2305 37.3047L37.793 20.3125H24.9023ZM24.9023 9.17969V14.6484H38.2812L38.7695 9.17969H24.9023Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.26756850522c91bdefa6914dfd097159.svg";
export { ForwardRef as ReactComponent };